import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "clients-expand__empty"
}
const _hoisted_2 = { class: "clients-expand__row-left" }
const _hoisted_3 = { class: "clients-expand__row-count" }
const _hoisted_4 = { class: "clients-expand__row-name" }
const _hoisted_5 = {
  key: 0,
  class: "clients-expand__row-address"
}
const _hoisted_6 = {
  key: 2,
  class: "clients-expand__row-roles"
}
const _hoisted_7 = { class: "clients-expand__row-roles-item-name" }

import { computed, ref } from "vue";
import ExpandListModal from "@/components/common/modal/ExpandListModal.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import { projectPageStore } from "@/store/project-page";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectClientsExpandModal',
  setup(__props, { expose: __expose }) {

const projectStore = projectPageStore()

const project = computed(() => projectStore.openedProject)
const canEdit = computed(() => project.value?.AttachedClientsAccess === 2)

const filter = ref('')

const filteredClients = computed(() => {
	const list = project.value?.AttachedClients ?? []
	const q = filter.value.trim().toLowerCase()
	if (!q) {
		return list
	}
	return list.filter((ac: any) =>
		`${ac.Name ?? ''} ${ac.Address ?? ''}`.toLowerCase().includes(q)
	)
})

const $modal = ref<InstanceType<typeof ExpandListModal> | null>(null)

const onOpen = () => {
	filter.value = ''
	$modal.value?.onOpen()
}
const onClose = () => $modal.value?.onClose()

const onDetach = async (id: number) => {
	try {
		await projectStore.detachClientFromProject(id)
	} catch (e) {
		console.error(e)
	}
}

const onDetachRole = async (clientId: number, roleId: number) => {
	try {
		await projectStore.detachRoleFromClient(clientId, roleId)
	} catch (e) {
		console.error(e)
	}
}

__expose({ onOpen, onClose })

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(ExpandListModal, {
    ref_key: "$modal",
    ref: $modal,
    title: "Клиенты",
    placeholder: "Название или адрес",
    filter: filter.value,
    "onUpdate:filter": _cache[0] || (_cache[0] = ($event: any) => (filter.value = $event))
  }, {
    default: _withCtx(() => [
      (!filteredClients.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Ничего не найдено "))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredClients.value, (ac, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: ac.Id,
          class: "clients-expand__row"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(index + 1) + ".", 1),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_router_link, {
                class: "clients-expand__row-name-str",
                to: { query: { page: 'client', id: ac.Id } },
                onClick: onClose
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(ac.Name), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              (ac.Address)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, " (" + _toDisplayString(ac.Address) + ") ", 1))
                : _createCommentVNode("", true),
              (canEdit.value)
                ? (_openBlock(), _createBlock(AppTooltip, {
                    key: 1,
                    text: "Удалить"
                  }, {
                    activator: _withCtx(() => [
                      _createVNode(AppIcon, {
                        class: "clients-expand__row-icon",
                        style: { marginTop: '-2px' },
                        name: "close-bold",
                        width: "12px",
                        color: "#D2D2D2",
                        "hover-color": "#BA4C4C",
                        cursor: "pointer",
                        onClick: ($event: any) => (onDetach(ac.Id))
                      }, null, 8, ["onClick"])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              (ac.Roles?.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ac.Roles, (role) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: role.Id,
                        class: "clients-expand__row-roles-item"
                      }, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(role.Name), 1),
                        (canEdit.value)
                          ? (_openBlock(), _createBlock(AppTooltip, {
                              key: 0,
                              text: "Удалить"
                            }, {
                              activator: _withCtx(() => [
                                _createVNode(AppIcon, {
                                  class: "clients-expand__row-icon",
                                  style: { marginTop: '-2px' },
                                  name: "close-bold",
                                  width: "12px",
                                  color: "#D2D2D2",
                                  "hover-color": "#BA4C4C",
                                  cursor: "pointer",
                                  onClick: ($event: any) => (onDetachRole(ac.Id, role.Id))
                                }, null, 8, ["onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["filter"]))
}
}

})